import AttachingDataAnalytics from "../../../../src/pages/resources/user-guides/tabs/attach-data/attaching-data/analytics.md";
import AttachingDataTarget from "../../../../src/pages/resources/user-guides/tabs/attach-data/attaching-data/target.md";
import * as React from 'react';
export default {
  AttachingDataAnalytics,
  AttachingDataTarget,
  React
};